import React from 'react'
import { UI_TEXT_CLEAR_SEARCH } from '../../constants/uiText'
import { Search } from '@mui/icons-material'
import { IconButton, InputAdornment, Paper, TextField, Typography } from '@mui/material'

export default function MobileSearchFilterCard({
  title = 'Detalles de reporte',
  value,
  onChange,
  onSubmit,
  onClear,
  placeholder = 'Buscar usuario por código o nombre...'
}) {
  const hasValue = String(value || '').length > 0

  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{
        p: 1.5,
        borderRadius: 1,
        borderColor: '#DADDE3',
        bgcolor: '#FFFFFF'
      }}
    >
      <Typography
        sx={{
          mb: 1.15,
          fontSize: 11,
          fontWeight: 500,
          color: '#5F6F82',
          lineHeight: 1.2,
          textTransform: 'uppercase',
          letterSpacing: '0.04em'
        }}
      >
        {title}
      </Typography>
      <TextField
        fullWidth
        size="small"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            onSubmit?.()
          }
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {hasValue ? (
                <IconButton
                  size="small"
                  edge="end"
                  aria-label={UI_TEXT_CLEAR_SEARCH}
                  onClick={() => onClear?.()}
                  sx={{ mr: -0.25 }}
                >
                  X
                </IconButton>
              ) : (
                <Search fontSize="small" color="action" />
              )}
            </InputAdornment>
          )
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            minHeight: 37,
            borderRadius: '4px',
            bgcolor: '#FFFFFF',
            fontSize: 12.5
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D7DCE3'
          },
          '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C6CED8'
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#AEB9C7',
            borderWidth: 1
          },
          '& .MuiInputBase-input': {
            py: 0.65,
            fontSize: 12.5,
            color: '#5F6F82',
            '&::placeholder': {
              color: '#8C98A8',
              opacity: 1
            }
          }
        }}
      />
    </Paper>
  )
}
